import moment from "moment";
import React from "react";
import { PrimayDropdown } from "components/common/dropdown";
import { TableInput } from "components/common/input";
import { faqType } from "service/constant/serviceConstant";
import type { IFaqList } from "service/interface/help";

interface Props {
  data: IFaqList;
  setData: React.Dispatch<React.SetStateAction<IFaqList>>;
}

export function DetailInfoTable({ data, setData }: Props) {
  const handleTypeDropdown = (id: number) => {
    setData((prev) => ({
      ...prev,
      type: id,
    }));
  };

  const handleTitleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setData((prev) => ({
      ...prev,
      title: e.target.value,
    }));
  };

  const handleContentInput = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setData((prev) => ({
      ...prev,
      content: e.target.value,
    }));
  };

  const handleLinkInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setData((prev) => ({
      ...prev,
      link: e.target.value,
    }));
  };

  return (
    <div>
      <div className="mb-[24px] flex items-center justify-between">
        <p className="m-0 text-[24px] font-semibold leading-[30px] text-black">
          게시글 정보
        </p>
      </div>
      <div className="w-full border-t-[2px] border-t-black p-0">
        <div className="flex h-[86px] w-full border-b-[1px] border-b-gray-1">
          <div className="flex h-full w-[148px] items-center justify-center bg-[#f4f4f4] text-M3 text-gray-4">
            질문 종류
          </div>
          <div className="flex h-full w-[318px] items-center px-[12px] text-M3 text-gray-5">
            <PrimayDropdown
              label="질문 종류"
              selectMenu={faqType[data.type]}
              menuList={[
                ...Object.entries(faqType).map(([key, value]) => ({
                  id: Number(key),
                  name: value,
                })),
              ]}
              onClick={handleTypeDropdown}
            />
          </div>
          <div className="flex h-full w-[164px] items-center justify-center bg-[#f4f4f4] text-M3 text-gray-4">
            생성일
          </div>
          <div className="flex h-full w-[303px] items-center gap-[48px] px-[24px] text-M3 text-gray-5">
            {data.createdAt && moment(data.createdAt).format("YYYY-MM-DD")}
          </div>
        </div>
        <div className="flex h-[86px] w-full border-b-[1px] border-b-gray-1">
          <div className="flex h-full w-[148px] items-center justify-center bg-[#f4f4f4] text-M3 text-gray-4">
            제목
          </div>
          <div className="flex h-full w-[787px] items-center px-[12px] text-M3 text-gray-5">
            <TableInput
              value={data.title}
              onChange={handleTitleInput}
              placeholder="제목을 입력해 주세요"
            />
          </div>
        </div>
        <div className="flex h-[252px] w-full border-b-[1px] border-b-gray-1">
          <div className="flex h-full w-[148px] items-center justify-center bg-[#f4f4f4] text-M3 text-gray-4">
            내용
          </div>
          <div className="flex h-full w-[787px] items-center px-[16px] text-M3 text-gray-5">
            <textarea
              value={data.content}
              onChange={handleContentInput}
              placeholder="내용을 입력해 주세요"
              className="h-[204px] w-full resize-none rounded-[4px] border-[1px] border-gray-1 bg-[#fafafa] px-[24px] py-[16px] text-M3 text-gray-5 outline-none placeholder:text-[#c6c6c6] focus:border-gray-5 focus:ring-0"
            />
          </div>
        </div>
        <div className="flex h-[86px] w-full border-b-[1px] border-b-gray-1">
          <div className="flex h-full w-[148px] items-center justify-center bg-[#f4f4f4] text-M3 text-gray-4">
            링크
          </div>
          <div className="flex h-full w-[787px] items-center px-[12px] text-M3 text-gray-5">
            <TableInput
              value={data.link}
              onChange={handleLinkInput}
              placeholder="링크를 입력해 주세요(ex: http:// )"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
